import { baseRoute } from '../../../constants/routes';

export const CALENDAR_PLAYERS_ROUTE = baseRoute + '/calendar-statistics/players';
export const CALENDAR_FILTER_PLAYERS_ROUTE = baseRoute + '/calendar-statistics/filtered-players';

export const CALENDAR_PLAYER_CHEATERS_ROUTE = baseRoute + '/cheaters';
export const DOWNLOAD_EXPORT_ROUTE = baseRoute + '/export/Calendar';
export const CALENDAR_DELETE_ALL_PLAYERS = baseRoute + '/calendars/delete-data';
export const PSEUDONONYMIZE_PLAYER_ROUTE = baseRoute + '/pseudononymize';

export const CALENDAR_PLAYER_ADVERTISING_CLICK_ROUTE = baseRoute + '/save-adv-hatch-view';
export const SEND_CALENDAR_ADVERTISING_CLICK = 'SEND_CALENDAR_CLICK';
export const SEND_CALENDAR_ADVERTISING_CLICK_SUCCESS = 'SEND_CALENDAR_CLICK_SUCCESS';

export const GET_CALENDAR_PLAYERS = 'GET_CALENDAR_PLAYERS';
export const GET_CALENDAR_PLAYERS_SUCCESS = 'GET_CALENDAR_PLAYERS_SUCCESS';

export const DELETE_USER_PLAYER = 'DELETE_USER_PLAYER';
export const DELETE_USER_PLAYER_SECCESS = 'DELETE_USER_PLAYER_SECCESS';

export const PSEUDONONYMIZE_USER_PLAYER = 'PSEUDONONYMIZE_USER_PLAYER';
export const PSEUDONONYMIZE_USER_PLAYER_SECCESS = 'PSEUDONONYMIZE_USER_PLAYER_SECCESS';

export const SET_CALENDAR_FILTER_PLAYER_SUCCESS = 'SET_CALENDAR_FILTER_PLAYER_SUCCESS';
export const SET_CALENDAR_FILTER_PLAYER = 'SET_CALENDAR_FILTER_PLAYER';

export const DOWNLOAD_EXPORT_FILE = 'DOWNLOAD_EXPORT_FILE';
export const DOWNLOAD_EXPORT_FILE_SUCCESS = 'DOWNLOAD_EXPORT_FILE_SUCCESS';

export const DELETE_CALENDAR_ALL_USER_PLAYERS = 'DELETE_CALENDAR_ALL_USER_PLAYERS';
export const DELETE_CALENDAR_ALL_USER_PLAYERS_SUCCESS = 'DELETE_CALENDAR_ALL_USER_PLAYERS_SUCCESS';